import React from 'react'

const Alert = () => {
  return (
    <div className='animate-fade-in-out   mx-auto '>
        <h1 className='flex items-center justify-center  p-1 tracking-wider font-semibold text-cyan-500'>
             Sent ✅
        </h1>
    </div>
  )
}

export default Alert